<template>
    <el-row class="musteri-kontrolleri">
        <v-toolbar dark color="deep-purple">
            <v-toolbar-title>Müşteri Makina Kontrolleri</v-toolbar-title>

            <v-spacer></v-spacer>

            <el-dropdown @command="handleCommand">
                <v-icon>mdi-dots-vertical</v-icon>

                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="kontrol-planlama">
                        Kontrol Planlama
                    </el-dropdown-item>
                    <el-dropdown-item command="kontrol-gecmisi">
                        Kontrol Geçmişi
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>

        </v-toolbar>

        <el-row type="flex" justify="space-between" style="margin: 2rem 0">
            <div style="width: 100%; margin-right: 1rem">
                <el-input v-model="search" placeholder="Kontrol musteri ara..." clearable>
                    <i class="el-icon-search" slot="prepend"/>
                </el-input>
            </div>
            <mak-kontrol-filtre v-model="filtre"/>
        </el-row>

        <el-tabs>

            <el-tab-pane v-for="t in tabs" :key="t.title">
                <template slot="label">{{t.title}} ({{formatted.filter(t.filter).length}})</template>

                <el-table :data="formatted.filter(t.filter)" empty-text="Yok" v-loading="loading">
                    <el-table-column prop="sirket_adi" label="Şirket" show-tooltip-when-overflow></el-table-column>
                    <!--    hidden -->
                    <el-table-column v-if="false" prop="musteri_makina_adi" label="Makina" show-tooltip-when-overflow></el-table-column>
                    <el-table-column prop="id" label="Durum">
                        <template slot-scope="{ row }">
                            <div v-if="row.musteri_durumu">
                                <el-tag type="warning">
                                    Demo ({{row.demo_gun_sayisi}})
                                </el-tag>
                                <br>
                            </div>
                            <el-tag v-if="row.id" type="success">Kontrol Edildi</el-tag>
                            <div v-else>
                                <el-tag :type="row.tagType">{{row.durum}}</el-tag>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="baslangic_zamani"
                            label="Başlangıç zamanı"
                            :formatter="formatDateTimeCol"></el-table-column>
                    <el-table-column
                            label="Lokasyon"
                            prop="link"
                            width="90">
                        <template slot-scope="{ row }">
                            <a v-if="row.link" :href="row.link" target="_blank">
                                <i
                                        class="el-icon-location"
                                        title="Konuma git"
                                        style="color: #13ce66"/>
                            </a>
                        </template>
                    </el-table-column>
                    <el-table-column width="90">
                        <template slot-scope="{ row }">
                            <el-button
                                    v-if="!row.id"
                                    plain
                                    icon="el-icon-check"
                                    @click="open(row)"></el-button>
                        </template>
                    </el-table-column>

                </el-table>
            </el-tab-pane>
        </el-tabs>



<!--        v-model="dialog"-->
<!--        fullscreen hide-overlay-->
<!--        transition="dialog-bottom-transition"-->
        <el-drawer
            fullscreen
            :visible.sync="dialog"
            :before-close="handleClose"
            title="Makina Kontrol"
            direction="btt"
            size="65%">

            <div class="mk-drawer-content">
                <el-form ref="form" :model="form" :rules="rules" label-position="top">
                    <el-form-item prop="tahsilat_yapildi" label="Tahsilat Yapıldı mı?">
                        <el-radio-group v-model="form.tahsilat_yapildi">
                            <el-radio-button label="1" name="1">
                                <i class="el-icon-circle-check"/> Yapıldı
                            </el-radio-button>
                            <el-radio-button label="0" name="0">
                                <i class="el-icon-circle-close"/> Yapılmadı
                            </el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item
                            v-if="form.tahsilat_yapildi === '1'"
                            prop="tahsilat_tutari"
                            label="Tahsilat Tutarı">
                        <el-input
                                v-model="form.tahsilat_tutari"
                                style="width: 100%"
                                placeholder="Tahsilat Tutarı"
                                type="number">
                            <span slot="prepend">₺</span>
                        </el-input>
                    </el-form-item>
                    <el-divider/>
                    <el-form-item prop="dolum_yapildi" label="Dolum Yapıldı mı?">
                        <el-radio-group v-model="form.dolum_yapildi">
                            <el-radio-button label="1" name="11">
                                <i class="el-icon-circle-check"/> Yapıldı
                            </el-radio-button>
                            <el-radio-button label="0" name="00">
                                <i class="el-icon-circle-close"/> Yapılmadı
                            </el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item
                        v-if="form.dolum_yapildi === '1'"
                        prop="dolum_ml"
                        label="Dolum mililitre">
                        <el-input
                            v-model="form.dolum_ml"
                            style="width: 100%"
                            placeholder="Dolum mililitre"
                            type="number">
                            <span slot="prepend">ml</span>
                        </el-input>
                    </el-form-item>

                    <el-divider/>

                    <el-form-item prop="not">
                        <el-input
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="Not girin"
                                v-model="form.not"></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button icon="el-icon-check" @click="save">Kaydet</el-button>
                    </el-form-item>
                </el-form>

            </div>
        </el-drawer>

    </el-row>
</template>

<script>
    import moment from 'moment';
    import Formatter from '@/mixins/Formatter.js';
    import MakKontrolFiltre from '@/components/filtreler/MakKontrolFiltre.vue'

    export default {
        name: 'musteri-kontrolleri',
        mixins: [Formatter],
        components: { MakKontrolFiltre },
        data() {
            return {
                search: null,
                filtre: null,
                tab: 'tab-0',
                dialog: false,
                loading: false,
                selected: null,
                list: [],
                form: {
                    musteri_id: null,
                    yil: null,
                    ay: null,
                    not: null,
                    kontrol_zamani: null,
                    tahsilat_yapildi: '1',
                    tahsilat_tutari: null,
                    dolum_yapildi: '1',
                    dolum_ml: null,
                },
                rules: {
                    not: [{required: true, message: 'Not gerekli', trigger: 'change'}],
                    tahsilat_yapildi: [{required: true, message: 'Tahsilat yapıldı gerekli', trigger: 'change'}],
                    dolum_yapildi: [{required: true, message: 'Dolum yapıldı gerekli', trigger: 'change'}],
                },
                rangeDiff: 3,
                tabs: [
                    {
                        title: 'Kiralık',
                        filter: (a) => !a.musteri_durumu,
                    },
                    {
                        title: 'Demo',
                        filter: (a) => a.musteri_durumu,
                    }
                ]
            };
        },
        computed: {
            params() {
                const start = moment().add(-1, 'days').format('YYYY-MM-DD');
                const end = moment().add(1, 'days').format('YYYY-MM-DD');
                return {
                    startDate: `${start} 00:00:00`,
                    endDate: `${end} 23:59:59`,
                };
            },
            startDay() {
                return moment().startOf('month').get('date');
            },
            endDay() {
                return moment().add(this.rangeDiff, 'days').get('date');
            },
            days() {
                let days = [];
                const pushDays = (start, end) => {
                    for (let day = start; day <= end; day++) {
                        days.push(day);
                    }
                };

                if (this.startDay > this.endDay) {
                    pushDays(this.startDay, 31);
                    pushDays(1, this.endDay);
                } else {
                    pushDays(this.startDay, this.endDay);
                }
                return days;
            },
            formatted() {
                let list = this.list
                    .map((d) => {
                        d.done = !!d.id;

                        if (d.latitude && d.longitude) {
                            d.latitude = parseFloat(d.latitude);
                            d.longitude = parseFloat(d.longitude);
                            d.link = `https://www.google.com/maps/search/?api=1&query=${d.latitude},${d.longitude}`;
                        }

                        if (d.musteri_durumu) { // demo musteri
                            // const baslangic_zamani = moment(d.baslangic_zamani);
                            const demo_bitis_zamani = moment(d.baslangic_zamani).add('days', d.demo_gun_sayisi);
                            d.diff = demo_bitis_zamani.diff(moment(), 'days');
                        } else {
                            let kontrol_zamani = moment(d.baslangic_zamani).set('month', moment().get('month'));
                            d.diff = kontrol_zamani.diff(moment(), 'days');
                            d.kontrol_zamani = kontrol_zamani;
                            if (d.diff > this.rangeDiff) {
                                // todo not sure on this
                                d.diff = d.diff - 30;
                            }
                        }
                        d.durum = d.diff < 0
                            ? 'Kontrol Zamanı Gecti'
                            : (d.diff > 0 ? 'Yaklaşan Kontrol' : 'Bugun kontrole gidilecek');
                        d.tagType = d.diff < 0
                            ? 'danger'
                            : (d.diff > 0 ? 'warning' : 'primary');

                        return d;
                    });

                if (this.filtre && this.filtre.filter) {
                    list = list.filter(this.filtre.filter);
                }

                if (this.search) {
                    list = list.filter((a) => a.sirket_adi.toLowerCase().includes(this.search.toLowerCase()));
                }

                return list;
            },
        },
        methods: {
            open(row) {
                this.dialog = true;
                this.selected = Object.assign({}, row);
                this.form.tahsilat_tutari = this.selected.makina_tutari;
            },
            handleClose() {
                this.dialog = false;
                this.selected = null;
            },
            handleCommand(command) {
                if (command === 'kontrol-planlama') {
                    this.$router.push({name: 'kontrol-planlama'});
                } else if (command === 'kontrol-gecmisi') {
                    this.$router.push({ name: 'kontrol-gecmisi' });
                }
            },
            fetch() {
                this.loading = true;
                this.$requests
                    .MusteriKontrol.getMusteriKontrolDays(this.days)
                    .then((data) => {
                        this.list = data;
                    })
                    .catch((e) => {
                        console.error('error', e);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
            save() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.submit();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            submit() {
                const form = Object.assign({}, this.form);
                form.ay = this.selected.kontrol_zamani.get('month');
                form.yil = this.selected.kontrol_zamani.get('year');
                form.kontrol_zamani = moment().format('YYYY-MM-DD HH:mm:ss');
                form.musteri_id = this.selected.musteri_id;

                if (form.tahsilat_yapildi === '1' && !form.tahsilat_tutari) {
                    this.$message.warning('Lütfen tahsilat tutarı giriniz!');
                    return;
                }

                if (form.tahsilat_yapildi === '0') {
                    delete form.tahsilat_tutari;
                }

                this.loading = true;
                this.$requests
                    .MusteriKontrol.createMusteriKontrol(form)
                    .then(() => {
                        this.$refs.form.resetFields();
                        this.handleClose();
                        this.fetch();
                    })
                    .catch((e) => {
                        console.error('error', e);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
        },
        mounted() {
            this.fetch();
            window.yns = moment
        },
    }
</script>

<style lang="scss" scoped>
    .musteri-kontrolleri {
        background: transparent;

        ::v-deep .el-table__expanded-cell {
            padding: 0;
        }

        .mk-drawer-content {
            display: flex;
            justify-content: center;
            flex-direction: column;
            width: 80%;
            margin: 0 auto;

            .el-input  {
                ::v-deep .el-input__inner {
                    width: 100%;
                }
            }
        }
    }
</style>
